<template>
  <div
    @mouseover="mouseEnter = true"
    @mouseleave="mouseEnter = false"
    class="temporary-position"
  >
    <md-card
      :class="[{ 'md-elevation-20': mouseEnter }]"
      class="snew-member-card"
    >
      <div class="card-header">
        <md-avatar class="little-header-avatar">
          <router-link :to="`/s-app/group-page/${request.groupId}`">
            <img src="../../../public/img/little-header-icons/portrait-group-header.png" alt="Group" />
          </router-link>
        </md-avatar>
        <span class="md-title">Group invite</span>
        <img src="../../../public/img/group-card-header.png" class="card-header-image" />
      </div>
      <md-card-header>
        <md-avatar>
          <router-link :to="`/s-app/group-page/${request.groupId}`">
            <img :src="getGroupImagePath(request.group)" alt="Group" />
          </router-link>
        </md-avatar>

        <div class="md-title">
          <router-link
            :to="`/s-app/group-page/${request.groupId}`"
            :data-cy="`linkGroupPage-${request.group.name}`"
          >
            {{ request.group.name }}
          </router-link>
        </div>
        <div class="md-subhead">
          {{ this.getGroupPrivacy(request.group) }} | {{ request.group.zip }}
        </div>
      </md-card-header>

      <md-card-content class="invitation-content">
        <div class="group-connection">
          <router-link :to="`/s-app/profile-page/${request.sUserId}`">
            <SUserAvatar
              :myUser="request.sUser"
              size="large"
              :isProfileAvatar="false"
            />
          </router-link>
          <md-icon class="ml-2 mr-2">east</md-icon>
          <router-link :to="`/s-app/group-page/${request.groupId}`">
            <md-avatar class="md-large">
              <img :src="getGroupImagePath(request.group)" alt="Group" />
            </md-avatar>
          </router-link>
        </div>

        <div class="group-connection-text">
          <div class="group-text">
            <span
              ><router-link :to="`/s-app/profile-page/${request.sUserId}`"
                ><span class="highlighted-word">{{
                  getUserName(request.sUser)
                }}</span></router-link
              >
              wants to join
            </span>
            <span
              >the
              <router-link :to="`/s-app/group-page/${request.groupId}`"
                ><span class="highlighted-word">{{
                  request.group.name
                }}</span></router-link
              ></span
            >
          </div>

          <div
            class="accept-reject-request"
            v-if="accept_state == 'WAITING_ACCEPT'"
          >
            <md-button
              class="md-icon-button md-raised md-fab md-primary"
              @click.prevent="accept"
              :data-cy="`user-request-${getUserName(request.sUser)}`"
            >
              <md-icon>done</md-icon>
            </md-button>
            <md-button
              class="md-icon-button md-raised md-fab md-primary"
              @click.prevent="decline"
            >
              <md-icon>close</md-icon>
            </md-button>
          </div>
          <div class="accepted-action-user" v-if="accept_state == 'ACCEPTED'">
            <md-icon>task_alt</md-icon>
            Request accepted
          </div>
          <div class="dennied-action-user" v-if="accept_state == 'DECLINED'">
            <md-icon>cancel</md-icon>
            Request declined
          </div>
        </div>
      </md-card-content>
      <LoadingSpinner
        position="absolute"
        v-if="accept_state === 'PROCESSING'"
      />
    </md-card>
  </div>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import CurrentUser from "@/mixins/CurrentUser.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import { mapActions } from "vuex";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
export default {
  name: "SNewRequestJoinMaterial",
  props: ["request"],
  mixins: [UserHelperVue, GroupHelperVue, CurrentUser],
  data() {
    return {
      accept_state: "WAITING_ACCEPT",
      mouseEnter: false,
    };
  },
  components: {
    // SButtonMaterial,
    LoadingSpinner,
    SUserAvatar,
  },
  methods: {
    ...mapActions(["acceptRequestToJoin", "declineRequestToJoin"]),
    openChat() {
      this.$emit("openWindowPopup");
    },
    async accept() {
      this.accept_state = "PROCESSING";
      await this.acceptRequestToJoin(this.request);
      await this.postUserGroupMessage({
        partner: this.request.sUserId,
        group: this.request.group.id,
        postMsg:
          "Hi, I accepted your request to join the " +
          this.request.group.name +
          " group",
        newChat: true,
      });
      this.accept_state = "ACCEPTED";
    },
    async decline() {
      this.accept_state = "PROCESSING";
      await this.declineRequestToJoin(this.request);
      await this.postUserGroupMessage({
        partner: this.request.sUserId,
        group: this.request.group.id,
        postMsg:
          "Hi, I declined your request to join the " +
          this.request.group.name +
          " group",
        newChat: true,
      });
      this.accept_state = "DECLINED";
    },
  },
};
</script>

// default card size
<style lang="scss" scoped>
.snew-member-card {
  width: 100%;
  max-width: 100%;
  min-width: 280px;
  height: 558px;
  color: $black !important;
  border-radius: 4px;
  border: 1px solid $grey;
}
.md-title a {
  color: $black;
}
.md-title a:hover {
  color: $primary;
}
</style>

<style lang="scss" scoped>
.temporary-position {
  width: 100%;
  display: flex;
  justify-content: center;
}
.invitation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}
.group-connection {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.group-connection i {
  color: $black !important;
}
.md-large {
  min-width: 100px !important;
  min-height: 100px !important;
}
.highlighted-word,
.self-highlighted-word {
  font-weight: bold;
}
.highlighted-word {
  color: $tertiary;
}
.group-connection-text {
  color: #000000;
  letter-spacing: 0.25px;
  .group-text {
    font-size: 20px;
    line-height: 26px;
  }
}
.group-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.request-action-message {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4rem;
  margin-left: 1rem;
  i {
    margin-top: 0.2rem;
  }
}
.send-msg-item-btn {
  margin-left: -43px;
}
.open-chat {
  cursor: pointer;
  margin-left: -28px;
  color: $tertiary;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-align: center;
}
.open-chat:hover {
  color: $primary;
}
.accepted-action-user,
.dennied-action-user {
  word-break: break-all;
  margin: 4.5rem 0 0.1rem 0rem;
  text-align: center;
}
.accepted-action-user i {
  color: $primary !important;
}
.dennied-action-user i {
  color: $danger !important;
}
.card-header {
  height: 8%;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 10px;
  border: unset;
}
.card-header .md-avatar {
  min-width: unset;
  height: 24px;
  width: 24px;
  background-color: white;
  z-index: 2;
  margin: 0;
}
.card-header .md-title {
  font-weight: bold;
  margin-left: 10px;
  color: white;
  font-size: 14px;
  z-index: 2;
}
.card-header-image {
  height: 8%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 75%;
}
.little-header-avatar {
  border-radius: 0;
  background-color: #69287B !important;
}
</style>

<style lang="scss">
.accept-reject-request {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 6rem !important;
  .md-button:last-child {
    margin-left: 12px;
  }
  .md-button:first-child .md-ripple {
    background: $primary;
  }
  .md-button:last-child .md-ripple {
    background: $danger;
  }
  i {
    color: $white !important;
  }
}
</style>
